import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { ButtonProps, Dialog } from '@optimus-web/core';

export const UNSUBMITTED_CHANGES_DIALOG_NAME = 'UnsubmittedChanges';

interface UnsubmittedChangesDialogProps {
    content?: React.ReactNode;
    onCancel: () => void;
    onDiscardChanges: () => void;
}

export const UnsubmittedChangesDialog = ({ content, onCancel, onDiscardChanges }: UnsubmittedChangesDialogProps) => {
    const actions: ButtonProps[] = [
        {
            children: <LocalizedText textKey={TextKey.UnsubmittedChangesCancel} />,
            onClick: onDiscardChanges,
            variant: 'tertiary',
            size: 'medium',
            type: 'submit',
        },
        {
            children: <LocalizedText textKey={TextKey.UnsubmittedChangesConfirm} />,
            onClick: onCancel,
            variant: 'primary',
            size: 'medium',
            type: 'submit',
        },
    ];

    return (
        <Dialog
            active
            title={<LocalizedText textKey={TextKey.UnsubmittedChangesTitle} />}
            actions={actions}
            onClose={onCancel}
        >
            {content || <LocalizedText textKey={TextKey.UnsubmittedChangesContent} />}
        </Dialog>
    );
};
